import { render, staticRenderFns } from "./LivingStyleGuide.vue?vue&type=template&id=4dc21cf8&"
import script from "./LivingStyleGuide.vue?vue&type=script&lang=js&"
export * from "./LivingStyleGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VContainer,VDivider,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dc21cf8')) {
      api.createRecord('4dc21cf8', component.options)
    } else {
      api.reload('4dc21cf8', component.options)
    }
    module.hot.accept("./LivingStyleGuide.vue?vue&type=template&id=4dc21cf8&", function () {
      api.rerender('4dc21cf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LivingStyleGuide.vue"
export default component.exports